module.exports = __webpack_public_path__ + "img/auth.6d48ee7e.png";